import { render, staticRenderFns } from "./Promocion.vue?vue&type=template&id=2b4968d8"
import script from "./Promocion.vue?vue&type=script&lang=js"
export * from "./Promocion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports